module.exports = __webpack_public_path__ + "static/green-dragon-poison-99bb57627005180168ab551bc3885174.webp";